import { API } from "../../backend";



export const createOrder = (userId, token, orderData) => {
    console.log("TK",token);
    console.log("UID",userId);
    return fetch(`${API}/order/create/${userId}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ order: orderData })
    })
      .then(reponse => {
        return reponse.json();
      })
      .catch(err => console.log(err));
  };
  




  // export const creataOrder = (userId, token, orderData ) => {
//     return fetch(`${API}/order/create/${userId}`,{
//         method:"POST",
//         headers:{
//             Accept: "application/json",
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`
//         },
//             body: JSON.stringify({order : orderData})
//     }).then(response => {
//         return response.json()
//     })
//     .catch(err => console.log(err))
// }